import React from 'react'
import { List } from 'antd'
import styled from 'styled-components'
import AdminAnnouncementItems from './AdminAnnouncementItems'

import AdminAnnouncementFooter from './AdminAnnouncementFooter'
import AdminAnnouncementHeader from './AdminAnnouncementHeader'
import { useNotice } from 'app/hooks/Events/notice'

const StyledList = styled(List)`
  background: #ffffff;
  border-radius: 24px;
  padding: 32px 36px;
  border: 1px solid #e4e8f5;
  box-shadow: 0 24px 48px -26px rgba(15, 23, 42, 0.22);

  .ant-list-header,
  .ant-list-footer {
    background: transparent;
    border: none;
    padding: 0;
  }

  .ant-list-header {
    margin-bottom: 24px;
  }

  .ant-list-footer {
    margin-top: 20px;
  }

  .ant-list-items {
    margin: 0;
  }

  .ant-list-items > .ant-list-item {
    background: #ffffff;
    border: 1px solid #e6ebf7;
    border-radius: 18px;
    padding: 26px 28px;
    margin-bottom: 18px;
    box-shadow: 0 18px 34px -26px rgba(71, 85, 105, 0.22);
    transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;
  }

  .ant-list-items > .ant-list-item:hover {
    transform: translateY(-2px);
    border-color: #d6ddf3;
    box-shadow: 0 22px 42px -24px rgba(71, 85, 105, 0.25);
  }

  .ant-list-items > .ant-list-item:last-child {
    margin-bottom: 0;
  }

  .ant-list-pagination {
    margin-top: 28px;
    text-align: center;
  }

  @media (max-width: 1024px) {
    padding: 28px 24px;

    .ant-list-item-extra {
      margin-left: 24px;
    }
  }

  @media (max-width: 768px) {
    padding: 24px 16px;
    border-radius: 18px;

    .ant-list-items > .ant-list-item {
      padding: 22px 18px;
      margin-bottom: 14px;
    }

    .ant-list-item-extra {
      margin: 14px 0 0;
      justify-content: flex-start;
    }
  }
`

const AdminAnnouncementList = () => {
	const { data, mutate } = useNotice()

	return (
		<StyledList
			itemLayout="vertical"
			size="large"
			pagination={{
				onChange: page => {
					mutate(page)
				},
				pageSize: 5,
				position: 'bottom',
			}}
			split={false}
			dataSource={data?.list}
			header={<AdminAnnouncementHeader />}
			footer={<AdminAnnouncementFooter data={data} />}
			renderItem={item => <AdminAnnouncementItems item={item} />}
		/>
	)
}
export default AdminAnnouncementList
